// Google Analytics 4 helper. Loads gtag only when REACT_APP_GA_MEASUREMENT_ID is set,
// so nothing is tracked (and no script loads) until you provide your GA4 Measurement ID.

const GA_ID = process.env.REACT_APP_GA_MEASUREMENT_ID;
let initialized = false;

export const initAnalytics = () => {
  if (initialized || !GA_ID || typeof window === 'undefined') return;
  initialized = true;

  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  document.head.appendChild(script);

  window.dataLayer = window.dataLayer || [];
  function gtag() { window.dataLayer.push(arguments); }
  window.gtag = gtag;
  gtag('js', new Date());
  gtag('config', GA_ID);
};

// Fire a GA4 event (no-op if GA isn't configured).
export const trackEvent = (name, params = {}) => {
  if (!GA_ID || typeof window === 'undefined' || typeof window.gtag !== 'function') return;
  window.gtag('event', name, params);
};

export const isAnalyticsEnabled = () => Boolean(GA_ID);
